/**
 * @fileoverview Toolbar contextuelle sous le topbar.
 * Gère uniquement les options d'affichage de la vue active : tri, présentation,
 * compteur de résultats. Les filtres de vue ont migré dans la sidebar de navigation.
 */

import * as viewState from './view-state.js';

/**
 * Initialise la toolbar : branche les écouteurs et synchronise l'UI avec viewState.
 * À appeler une seule fois au démarrage, après que le DOM est prêt.
 */
export function initToolbar() {
    // --- Branchement du sélecteur de tri ---
    const sortSelect = document.getElementById('toolbar-sort');
    sortSelect?.addEventListener('change', () => {
        viewState.set({ sort: sortSelect.value });
    });

    // --- Branchement du switch présentation (vignettes / liste) ---
    for (const btn of document.querySelectorAll('.toolbar-layout [data-layout]')) {
        btn.addEventListener('click', () => {
            viewState.set({ layout: btn.dataset.layout });
        });
    }

    // --- Synchronisation : initiale + à chaque changement ---
    viewState.subscribe(_syncUI);
    _syncUI(viewState.get());
}

/**
 * Met à jour le compteur de résultats affiché dans la toolbar.
 * @param {number} count - Nombre de BD affichées dans la vue courante.
 */
export function updateCount(count) {
    const el = document.getElementById('toolbar-count');
    if (!el) return;

    el.textContent = count === 0
        ? 'Aucun résultat'
        : `${count} résultat${count > 1 ? 's' : ''}`;
}

/**
 * Reflète l'état courant sur les contrôles de la toolbar et sur la liste.
 * @private
 * @param {{ filter: string, layout: string, sort: string }} state
 */
function _syncUI(state) {
    // Sélecteur de tri : aligné sur la valeur courante
    const sortSelect = document.getElementById('toolbar-sort');
    if (sortSelect && sortSelect.value !== state.sort) {
        sortSelect.value = state.sort;
    }

    // Switch présentation
    for (const btn of document.querySelectorAll('.toolbar-layout [data-layout]')) {
        const active = btn.dataset.layout === state.layout;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
    }

    // Classe layout + exposition du filtre courant via data-filter
    // (permet de cibler des styles spécifiques par vue, ex. mise en avant du prêt)
    const list = document.getElementById('comic-list');
    if (list) {
        list.classList.toggle('is-list-view', state.layout === 'list');
        list.dataset.filter = state.filter;
    }
}
